import { render } from "./LanguagesSection.vue?vue&type=template&id=1bcfae67&scoped=true"
import script from "./LanguagesSection.vue?vue&type=script&lang=js"
export * from "./LanguagesSection.vue?vue&type=script&lang=js"

import "./LanguagesSection.vue?vue&type=style&index=0&id=1bcfae67&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcfae67"]])

export default __exports__